import script from "./GuideButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuideButton.vue?vue&type=script&lang=ts&setup=true"

import "./GuideButton.vue?vue&type=style&index=0&id=2deb8011&lang=scss"

const __exports__ = script;

export default __exports__